export default "__VITE_ASSET__Xra_pdRy__"